module.exports = __webpack_public_path__ + "static/media/nibrt.8680c50f.png";